module.exports = __webpack_public_path__ + "d664201f/img/SOURCERY_poweredby_web.9819842b.png";